export function Section({ children }) {
  return <div className="py-16">{children}</div>;
}

export function SectionTitle({ children }) {
  return <h2 className="mb-8 text-2xl font-bold">{children}</h2>;
}
